import React, { useState, useRef, useEffect } from "react";
import "./NavBar.css";
import { Link, useNavigate } from "react-router-dom";
import { FaCartArrowDown } from "react-icons/fa";
import { CgProfile } from "react-icons/cg";
import Profile from "../Profile/Profile";
import { Logo2 } from "../../Assests/Assests";
import { TbListCheck } from "react-icons/tb";
import MarqueeBanner from "./MarqueeBanner";



const NavBar = () => {
  const [isProfileVisible, setIsProfileVisible] = useState(false);
  const [categories, setCategories] = useState([]);
  const [showCollections, setShowCollections] = useState(false);
  const [collectionsTab, setCollectionsTab] = useState("colors");
  const collectionsRef = useRef(null);
  const profileRef = useRef(null);
  const hideTimeout = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://admin.riymay.com/api/v1/admin/get/all/main/product-categories")
      .then(r => r.json())
      .then(d => setCategories(d.response || d.mainProductCategories || []))
      .catch(() => {});
  }, []);

  const toggleProfile = (event) => {
    event.stopPropagation(); // Prevent click from reaching document
    setIsProfileVisible((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (profileRef.current && !profileRef.current.contains(event.target)) {
      setIsProfileVisible(false);
    }
  };

  useEffect(() => {
    if (isProfileVisible) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [isProfileVisible]);

  const handleProtectedNavigation = (path) => {
    const token = localStorage.getItem("userToken");
    if (!token) {
      navigate("/login");
    } else {
      navigate(path);
    }
  };

  return (
    <div className="navbar-container">
      <MarqueeBanner />
      <nav className="navbar">
        <div className="navbar-section">
          <nav className="navbar-links">
            <div
              className="navbar-link navbar-link--dropdown"
              ref={collectionsRef}
              onMouseEnter={() => {
                if (hideTimeout.current) clearTimeout(hideTimeout.current);
                setShowCollections(true);
              }}
              onMouseLeave={() => {
                hideTimeout.current = setTimeout(() => setShowCollections(false), 200);
              }}
            >
              Collections
              {showCollections && (
                <div className="collections-megamenu">
                  {/* Horizontal tabs */}
                  <div className="megamenu-tabs">
                    <button
                      className={`megamenu-tab ${collectionsTab === "colors" ? "megamenu-tab-active" : ""}`}
                      onClick={() => setCollectionsTab("colors")}
                    >
                      Colors
                    </button>
                    <button
                      className={`megamenu-tab ${collectionsTab === "categories" ? "megamenu-tab-active" : ""}`}
                      onClick={() => setCollectionsTab("categories")}
                    >
                      Categories
                    </button>
                  </div>

                  {/* Items below the tabs */}
                  <div className="megamenu-items">
                    {collectionsTab === "colors" && (
                      <>
                        {[
                          { label: "Warms", value: "warms" },
                          { label: "Cools", value: "cools" },
                          { label: "Neutrals", value: "neutrals" },
                        ].map(c => (
                          <Link
                            key={c.value}
                            to={`/newproduct?colorGroup=${c.value}`}
                            className="megamenu-item"
                            onClick={() => setShowCollections(false)}
                          >
                            {c.label}
                          </Link>
                        ))}
                      </>
                    )}
                    {collectionsTab === "categories" && (
                      <>
                        {categories.map(cat => (
                          <Link
                            key={cat._id}
                            to={`/newproduct?category=${encodeURIComponent(cat.name)}`}
                            className="megamenu-item"
                            onClick={() => setShowCollections(false)}
                          >
                            {cat.name}
                          </Link>
                        ))}
                      </>
                    )}
                  </div>
                </div>
              )}
            </div>
            <Link to="/newproduct" className="navbar-link">All Products</Link>
            <Link to="/spectacle" className="navbar-link">Spectacle</Link>
            <Link to="/About" className="navbar-link">About</Link>
          </nav>
        </div>
        <div className="navbar-section">
          <Link to="/">
            <img src={Logo2} alt="Main Logo" className="main-logo" />
          </Link>
        </div>
        <div className="navbar-section">
          <div className="navbar-icons">
            <button className="icon-button nav-tip" data-tip="Orders" onClick={() => handleProtectedNavigation("/order-history")}>
              <TbListCheck />
            </button>
            <button className="icon-button nav-tip" data-tip="Cart" onClick={() => handleProtectedNavigation("/cart")}>
              <FaCartArrowDown />
            </button>
            <button className="icon-button nav-tip" data-tip="Profile" onClick={toggleProfile}>
              <CgProfile />
            </button>
          </div>
        </div>
      </nav>

{isProfileVisible && (
        <div className="user-profilecard" ref={profileRef}>
          <Profile />
        </div>
      )}
    </div>
  );
};

export default NavBar;
